import { PAYMENT_URLS } from "../../apiConfig";
import { PAYMENT_ERRORS } from "../../../common/constants/customerModule/paymentConstants";
import apiClient from "../../apiInstance";

export const fetchPayments = async () => {
	try {
		const response = await apiClient.get(PAYMENT_URLS.FETCH_PAYMENTS);
		return response.data;
	} catch (error) {
		console.error(PAYMENT_ERRORS.FETCH_PAYMENTS_ERROR, error);
		throw error;
	}
};

export const fetchPaymentByCustomer = async (customerguid, paymentType = null) => {
	try {
		const params = { customerguid };
		if (paymentType) params.paymentType = paymentType;
		const response = await apiClient.get(PAYMENT_URLS.FETCH_PAYMENTS_BY_CUSTOMER, {
			params,
		});
		return response.data;
	} catch (error) {
		console.error(PAYMENT_ERRORS.FETCH_PAYMENTS_ERROR, error);
		throw error;
	}
};

export const fetchPaymentByCustomerChart = async (customerguid) => {
	try {
		const response = await apiClient.get(PAYMENT_URLS.FETCH_PAYMENTS_BY_CUSTOMER_CHART, {
			params: { customerguid },
		});	
		return response.data;
	} catch (error) {
		console.error(PAYMENT_ERRORS.FETCH_PAYMENTS_ERROR, error);
		throw error;
	}
};

export const fetchPromisesByCustomer = async (customerguid, paymentType = null) => {
	try {
		const params = { customerguid };
		if (paymentType) params.paymentType = paymentType;
		const response = await apiClient.get(PAYMENT_URLS.FETCH_PROMISES_BY_CUSTOMER, {
			params,
		});	
		return response.data;
	} catch (error) {
		console.error(PAYMENT_ERRORS.FETCH_PROMISES_ERROR, error);
		throw error;
	}
};

export const fetchPromisesByCustomerChart = async (customerguid) => {
	try {
		const response = await apiClient.get(PAYMENT_URLS.FETCH_PROMISES_BY_CUSTOMER_CHART, {
			params: { customerguid },
		});	
		return response.data;
	} catch (error) {
		console.error(PAYMENT_ERRORS.FETCH_PROMISES_ERROR, error);
		throw error;
	}
};


